export const mockServices = [
  {
    id: 1,
    category: "Sesli Danışmanlıklar",
    categoryIcon: "ri-mic-line",
    categoryColor: "#a855f7",
    services: [
      {
        id: 101,
        name: "Sinastri",
        price: 1800,
        deliveryTime: "Randevu günü",
        suitableDays: "Cumartesi, Pazar",
        duration: "60 dk",
        active: true,
        bookings: 14,
      },
      {
        id: 102,
        name: "Doğum Haritası",
        price: 2000,
        deliveryTime: "Randevu günü",
        suitableDays: "Cumartesi, Pazar",
        duration: "75 dk",
        active: true,
        bookings: 22,
      },
      {
        id: 103,
        name: "Solar Return",
        price: 1600,
        deliveryTime: "Randevu günü",
        suitableDays: "Cumartesi, Pazar",
        duration: "45 dk",
        active: true,
        bookings: 9,
      },
      {
        id: 104,
        name: "İlişki Analizi",
        price: 2200,
        deliveryTime: "Randevu günü",
        suitableDays: "Cumartesi, Pazar",
        duration: "90 dk",
        active: true,
        bookings: 17,
      },
      {
        id: 105,
        name: "Geçmiş Yaşam ve Karmalar",
        price: 2500,
        deliveryTime: "Randevu günü",
        suitableDays: "Cumartesi, Pazar",
        duration: "90 dk",
        active: false,
        bookings: 6,
      },
    ],
  },
  {
    id: 2,
    category: "Yazılı Danışmanlıklar",
    categoryIcon: "ri-file-text-line",
    categoryColor: "#f97316",
    services: [
      {
        id: 201,
        name: "Doğum Haritası",
        price: 1200,
        deliveryTime: "3-5 gün",
        suitableDays: "Hafta içi + hafta sonu",
        duration: "Yazılı rapor",
        active: true,
        bookings: 34,
      },
      {
        id: 202,
        name: "Yıllık Öngörü",
        price: 1500,
        deliveryTime: "4-6 gün",
        suitableDays: "Hafta içi + hafta sonu",
        duration: "Yazılı rapor",
        active: true,
        bookings: 28,
      },
      {
        id: 203,
        name: "Sinastri",
        price: 1400,
        deliveryTime: "3-5 gün",
        suitableDays: "Hafta içi + hafta sonu",
        duration: "Yazılı rapor",
        active: true,
        bookings: 19,
      },
      {
        id: 204,
        name: "Rektifikasyon",
        price: 1800,
        deliveryTime: "4-7 gün",
        suitableDays: "Hafta içi + hafta sonu",
        duration: "Yazılı rapor",
        active: true,
        bookings: 11,
      },
      {
        id: 205,
        name: "Eleksiyon (Zaman Belirleme)",
        price: 1300,
        deliveryTime: "3-4 gün",
        suitableDays: "Hafta içi + hafta sonu",
        duration: "Yazılı rapor",
        active: true,
        bookings: 15,
      },
      {
        id: 206,
        name: "Astrocartography",
        price: 1600,
        deliveryTime: "4-5 gün",
        suitableDays: "Hafta içi + hafta sonu",
        duration: "Yazılı rapor",
        active: true,
        bookings: 8,
      },
      {
        id: 207,
        name: "İlişki Analizi",
        price: 1400,
        deliveryTime: "3-5 gün",
        suitableDays: "Hafta içi + hafta sonu",
        duration: "Yazılı rapor",
        active: true,
        bookings: 21,
      },
      {
        id: 208,
        name: "Geçmiş Yaşam ve Karmalar",
        price: 1700,
        deliveryTime: "5-7 gün",
        suitableDays: "Hafta içi + hafta sonu",
        duration: "Yazılı rapor",
        active: false,
        bookings: 7,
      },
    ],
  },
  {
    id: 3,
    category: "Günlük Danışmanlıklar",
    categoryIcon: "ri-sun-line",
    categoryColor: "#d4af37",
    services: [
      {
        id: 301,
        name: "Horary (Saat Astrolojisi)",
        price: 800,
        deliveryTime: "Aynı gün (20:00-24:00)",
        suitableDays: "Her gün",
        duration: "Anlık analiz",
        active: true,
        bookings: 42,
      },
    ],
  },
];
